import { render } from "./ViewGroup.vue?vue&type=template&id=f773d5ec&scoped=true"
import script from "./ViewGroup.vue?vue&type=script&lang=js"
export * from "./ViewGroup.vue?vue&type=script&lang=js"

import "./ViewGroup.vue?vue&type=style&index=0&id=f773d5ec&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f773d5ec"]])

export default __exports__